import React from 'react'
import seqStore from '../../store/seqStore'

export default function MidiChannel() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const midiCh = seqStore((state) => state.settings.midiCh)
    const setMidiCh = seqStore((state) => state.setMidiCh)

    // MIDI CHANNEL CONTROLS
    const handleMidiCh = (e) => {
        const value = e.target.value
        setMidiCh(currentTrack, value)
    }

    const resetMidiCh = (e) => {
        setMidiCh(currentTrack, 0)
    }
    
    return (
        <div id='midiChInput'>
            <label htmlFor="root note">Midi Channel <span>{Number(midiCh[currentTrack]) + 1}</span></label>
            <input id='enabledInput' type="range" min={0} max={15} step='1' value={midiCh[currentTrack]} onChange={e => handleMidiCh(e)} onDoubleClick={resetMidiCh}/>
        </div>
    )
}
